import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	chartTitle: {
		id: 'software-deployment-frequency-report.deployment-frequency-bar-chart.chart-title',
		defaultMessage: 'Deployment frequency',
		description: 'The bar chart title that shows historical deployment frequency over 12 weeks.',
	},
	titleHelpTooltip: {
		id: 'software-deployment-frequency-report.deployment-frequency-bar-chart.title-help-tooltip',
		defaultMessage:
			'Use the 12-week average to see how your team is performing and what corrective actions you need to make based on the deployment frequency comparisons.',
		description:
			'The message that is displayed when the mouse is hovered on the question mark beside the bar chart title. It explains how deployment frequency historical data is useful to the user.',
	},
});
